import React, { useEffect, useState } from "react";
import { SiteTitle } from "../SiteTitle";
import { api_url } from "../globalFunction/global_string";
import DataTable from 'react-data-table-component';
import { SelectNet } from "../BasicComponents/SelectNet";
import { SelectUnitproxyApply } from "../BasicComponents/SelectUnitproxyApply";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Col } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function UrlReportZipPassword() {
    const [data, setData] = useState([]); // 初始狀態設為空數組
    const [selectnet, setSelectnet] = useState("");
    const [local_net_name, setLocal_net_name] = useState("");
    const [selectedUnitproxy, setSelectedUnitproxy] = useState("");
    const [local_unit_proxy_name, setLocal_unit_proxy_name] = useState("");
    const [filterText, setFilterText] = useState('');

    // 函數來發送POST請求
    const fetchLocalNetData = async () => {
        const userType = localStorage.getItem('login_user_type') || ''; // 從localStorage獲取user_type
        const formData = new FormData();
        formData.append('user_type', userType); // 加入user_type
        if (selectnet) {
            formData.append('local_net_id', selectnet); // 如果有selectnet則加入
        }
        if (selectedUnitproxy) {
            formData.append('local_unit_id', selectedUnitproxy); // 如果有selectedUnitproxy則加入
        }
        try {
            const response = await fetch(api_url + "/api/Async/GetUrlReportData", {
                method: "POST",
                headers: {
                    "Authorization": localStorage.getItem('accessToken')
                },
                body: formData
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonData = await response.json();
            setData(jsonData.row || []); // 設置數據
        } catch (error) {
            console.error('Fetching data failed: ', error);
        }
    };

    // useEffect在組件掛載時執行
    useEffect(() => {
        fetchLocalNetData();
        if (selectnet || selectedUnitproxy) {
            fetchLocalNetData();
        }
    }, [selectnet, selectedUnitproxy]);

    const formatSerialNumber = (row) => {
        const originalFormat = row.build_date;
        const newFormat = originalFormat.replace(/\//g, "").replace(/:/g, "").replace(/ /g, "");
        return `${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`;
    };

    // 處理網域選擇
    const handleNetSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectnet(value);
        setLocal_net_name(selectedName);
        setSelectedUnitproxy(''); // 清空單位
        setLocal_unit_proxy_name(''); // 清空單位名稱
    };

    const selectUnitproxyApply = (data) => {
        const { value, selectedName } = data;
        setSelectedUnitproxy(value);
        setLocal_unit_proxy_name(selectedName);
    };

    const handleFilterChange = (e) => {
        setFilterText(e.target.value);
    };

    const filteredData = data.filter((row) => {
        const searchString = `${formatSerialNumber(row)}${row.local_net_name} ${row.local_unit_name} ${row.reportencryption}`.toLowerCase();
        return searchString.includes(filterText.toLowerCase());
    });

    const columns = [
        {
            name: '流水號',
            selector: row => formatSerialNumber(row),
            sortable: true,
        },
        {
            name: '網址',
            selector: row => <a href={row.url_addr} target="_blank" rel="noopener noreferrer">{row.url_name}</a>,
            sortable: true,
        },
        {
            name: '區網名稱',
            selector: row => row.local_net_name,
            sortable: true,
        },
        {
            name: '單位名稱',
            selector: row => row.local_unit_name,
            sortable: true,
        },
        {
            name: '報告密碼',
            selector: row => row.reportencryption,
            sortable: true,
        },
    ];

    return (
        <div className="container mt-5">
            <SiteTitle />
            <div>
                <h1 id="tableLabel" className="mb-3">報告解壓縮密碼</h1>
                <div id="site_manage" className="row col-12 mb-5 justify-content-center">
                    <div id="site_manage" className="row col-12 mb-5 justify-content-center">
                        <FormGroup row className="col-12 col-md-10 col-lg-8">
                            <Label for="local_net_id" sm={2}>區網名稱</Label>
                            <Col sm={6}>
                                <SelectNet
                                    parentName={'superS'}
                                    id={'excel_net_name'}
                                    name={'excel_net_name'}
                                    requiredAPI={'/api/JRCC/GetLocalNetId'}
                                    handleNetSelectChange={handleNetSelectChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row className="col-12 col-md-10 col-lg-8">
                            <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
                            <Col sm={6}>
                                <SelectUnitproxyApply
                                    parentName={'superS'}
                                    id={'excel_unit_proxy_name'}
                                    name={'excel_unit_proxy_name'}
                                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                    SelectUnitproxyApply={selectUnitproxyApply}
                                    selectnet={selectnet}
                                    local_net_name={local_net_name}
                                />
                            </Col>
                        </FormGroup>
                    </div>
                </div>
                <DataTable
                    columns={columns}
                    data={filteredData.slice(0, 100)} // Apply filtering before slicing
                    pagination
                    paginationPerPage={20}
                    paginationRowsPerPageOptions={[20, 40, 60, 80, 100]}
                    highlightOnHover
                    responsive
                    onRowClicked={(row) => console.log(row)} // Add this line if you want to handle row clicks
                    subHeader
                    subHeaderComponent={
                        <div className="row  justify-content-end">
                            <div className="col-md-4 input-group">
                                <div className="input-group-prepend bg-info">
                                    <span className="input-group-text bg-info" style={{ borderTopLeftRadius: '0.7rem', borderBottomLeftRadius: '0.7rem' }}>
                                        <FontAwesomeIcon icon={faSearch} color="white" />
                                    </span>
                                </div>
                                <Input
                                    type="text"
                                    placeholder="篩選-請輸入文字..."
                                    value={filterText}
                                    onChange={handleFilterChange}
                                    className="form-control"
                                />
                            </div>
                        </div>
                    }
                />
            </div>
        </div>
    );
}

export default UrlReportZipPassword;
